export default "__VITE_ASSET__4cea2d5a__"